module.exports = __webpack_public_path__ + "676366abafb25ab3c9206686f757383e.svg";